import useLocalStorage from 'app/common/hooks/useLocalStorage';

import { useThemeDetector } from './useThemeDetector';
import { USE_DARK_THEME } from '../Theme';

export const PARTOO_THEME_KEY = 'partoo_theme';

export const usePartooTheme = (): [string, (theme: string) => void] => {
    const isDarkBrowserTheme = useThemeDetector();
    const systemTheme = isDarkBrowserTheme ? 'dark' : 'light';

    const [partooTheme, setPartooTheme] = useLocalStorage<string | undefined>(
        PARTOO_THEME_KEY,
        undefined,
        {
            maxAge: 3 * 24 * 3600, // 3 days
        },
    );
    const appliedTheme = USE_DARK_THEME ? (partooTheme ? partooTheme : systemTheme) : 'light';

    return [appliedTheme, setPartooTheme];
};
